export default "__VITE_ASSET__RI7BCBzF__"